module.exports = __webpack_public_path__ + "img/077-visionary.7b5cb75b.png";